import { render, staticRenderFns } from "./webAlert.vue?vue&type=template&id=66ca52bb&"
import script from "./webAlert.vue?vue&type=script&lang=js&"
export * from "./webAlert.vue?vue&type=script&lang=js&"
import style0 from "./webAlert.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports